import React from 'react';
import { useTranslation } from 'react-i18next';
import { URLS, USER_GROUPS, useAuth0 } from '@livingsecurity/shared';
import * as Styled from './style';

const DashboardReturnBar = () => {
  const { isUserHasRights } = useAuth0();
  const isDashboard = window.location.href.indexOf(URLS.dashboard) > -1;
  const isAdmin = isUserHasRights([
    USER_GROUPS.LS_ADMIN,
    USER_GROUPS.CUSTOMER_ADMIN,
    USER_GROUPS.ENTERPRISE_ADMIN,
    USER_GROUPS.TRAINING_DEMO,
    USER_GROUPS.TEAMS_COLLABORATOR,
    USER_GROUPS.TEAMS_CUSTOMER_ADMIN,
    USER_GROUPS.TEAMS_LS_ADMIN,
    USER_GROUPS.UNIFY_LS_ADMIN,
    USER_GROUPS.UNIFY_CUSTOMER_ADMIN,
    USER_GROUPS.UNIFY_CUSTOMER_LIMITED_ADMIN,
    USER_GROUPS.PHISHING_CUSTOMER_ADMIN,
    USER_GROUPS.PHISHING_LS_ADMIN,
  ]);

  const userRoleRedirect = () => {
    if (isUserHasRights([USER_GROUPS.CUSTOMER_ADMIN, USER_GROUPS.ENTERPRISE_ADMIN, USER_GROUPS.LS_ADMIN])) {
      return URLS.userManagement;
    }
    if (
      isUserHasRights([
        USER_GROUPS.UNIFY_LS_ADMIN,
        USER_GROUPS.UNIFY_CUSTOMER_ADMIN,
        USER_GROUPS.UNIFY_CUSTOMER_LIMITED_ADMIN,
      ])
    ) {
      return URLS.unify;
    }
    if (
      isUserHasRights([USER_GROUPS.TEAMS_CUSTOMER_ADMIN, USER_GROUPS.TEAMS_LS_ADMIN, USER_GROUPS.TEAMS_COLLABORATOR])
    ) {
      return URLS.teamsBase;
    }
    if (isUserHasRights([USER_GROUPS.PHISHING_CUSTOMER_ADMIN, USER_GROUPS.PHISHING_LS_ADMIN])) {
      return URLS.phishing;
    }
    if (isUserHasRights([USER_GROUPS.TRAINING_DEMO])) {
      return URLS.catalog;
    }
    return URLS.base;
  };

  const { t } = useTranslation('playerDashboard');

  return (
    <>
      {isDashboard && isAdmin && (
        <Styled.DashboardReturnBar>
          <Styled.Link to={userRoleRedirect()}>
            <span style={{ marginRight: '8px' }}>
              <i className="fa-solid fa-arrow-left" />
            </span>
            {t('back-to-admin')}
          </Styled.Link>
        </Styled.DashboardReturnBar>
      )}
    </>
  );
};

DashboardReturnBar.propTypes = {};
export default DashboardReturnBar;
